import { assignDefaultValue } from "features/contracting/helpers/contractingFormHelper";
import { Commodity } from "features/shared/enums/commodity";
import DistributionRateTypeEnumDTO from "features/shared/enums/dynamic/DistributionRateTypeEnumDTO";
import { FormFields } from "features/shared/forms/hooks/useForm";
import { TPrefixedFunction } from "features/shared/hooks/useTranslationWithPrefix";
import { TFunction } from "i18next";

export const getFormInitValues = (storeValues: FormFields) => {
  // assign default place of delivery address same as main address
  let defaultValues = assignDefaultValue(
    storeValues,
    "placeOfDeliveryAddressIsSameAsMain",
    true
  );
  // assign default place of delivery address same as main address
  defaultValues = assignDefaultValue(
    defaultValues,
    "placeOfDeliveryAddressHasCadastralInfo",
    false
  );

  return defaultValues;
};

export const getPlaceOfDeliveryTrans = (
  commodity: Commodity,
  tLabels: TPrefixedFunction,
  transType: "label" | "placeholder"
) => {
  let type = "";

  if (commodity === Commodity.Electricity) {
    type = "ean";
  } else if (commodity === Commodity.Gas) {
    type = "eic";
  }

  return tLabels(`${type}.${transType}`);
};

export const getYearlyConsumptionTrans = (
  commodity: Commodity,
  tLabels: TFunction,
  transType: "label" | "placeholder"
) => {
  let type = "";

  if (commodity === Commodity.Electricity) {
    type = "electricity";
  } else if (commodity === Commodity.Gas) {
    type = "gas";
  }

  return tLabels(
    `yearlyConsumption.${type}.${transType}`
  );
};

export const isMultipleDistributionRate = (
  commodity: Commodity,
  distributionRate: string,
  distributionRates: DistributionRateTypeEnumDTO[]
) => {
  if (commodity === Commodity.Electricity) {
    const rate = distributionRates.find((x) => x.code === distributionRate);
    return rate ? !rate.isSingleRate : false;
  }

  return false;
};
